module.exports = __webpack_public_path__ + "font/Alibaba-PuHuiTi-Regular.otf";